if(typeof document.currentScript === 'undefined') {
    throw new Error('Unsupported browser');
}

const url = new URL((document.currentScript as HTMLScriptElement).src);
const widgetLink = url.href.substring(0, url.href.lastIndexOf('/') + 1) + '../../';
// eslint-disable-next-line
// @ts-ignore
__webpack_public_path__ = widgetLink;